// Ochrana proti robotům — Cloudflare Turnstile (rozhodnutí uživatele 2026-11-02).
// Stejný soubor je v portálu (bozp-portal/src/captcha.js) — měnit oba.
// Supabase Auth (Authentication → Bot and Abuse Protection, tajný klíč) pak
// vyžaduje token u registrace, přihlášení heslem, zapomenutého hesla a opakovaného
// potvrzovacího e-mailu. Bez SITE_KEY je ochrana vypnutá (captchaToken vrátí
// undefined) — klíč doplnit DŘÍV, než se ochrana zapne v Supabase.
// Widget je „interaction-only“: běžně neviditelný, úlohu ukáže jen při podezření.
// prefetchCaptcha() při otevření formuláře připraví token dopředu (rychlejší přihlášení).
export const TURNSTILE_SITE_KEY = '0x4AAAAAAFxOQMmn944GDZeE';

let loading = null;
function loadApi() {
  if (window.turnstile) return Promise.resolve();
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => { loading = null; reject(new Error('captcha_load')); };
      document.head.appendChild(s);
    });
  }
  return loading;
}

export const CAPTCHA_ERROR = 'Ověření, že nejste robot, se nepodařilo. Zkuste to prosím znovu.';
// Text chyby i s kódem od Cloudflare (pro dohledání příčiny).
export function captchaErrorText(err) {
  const code = err && err.code ? String(err.code) : '';
  return CAPTCHA_ERROR + (code ? ' (kód ' + code + ')' : '');
}
function captchaError(code) { const e = new Error('captcha'); e.code = code || ''; return e; }

// Nový token od Cloudflare (render widgetu). `container` = místo ve formuláři,
// kde se případná úloha ukáže (jinak konec stránky). Přechodné chyby (kódy 3xx/6xx…)
// Turnstile sám zopakuje — vzdáváme se jen u chyb nastavení (1xx klíč/doména,
// 4xx) nebo po 45 s.
function freshToken(container) {
  return loadApi().then(() => new Promise((resolve, reject) => {
    const box = document.createElement('div');
    box.className = 'captcha-box';
    box.style.cssText = 'display:flex;justify-content:center;margin:8px 0';
    (container || document.body).appendChild(box);
    let id = null, finished = false, lastCode = '';
    const done = (fn, v) => {
      if (finished) return; finished = true;
      clearTimeout(timer);
      setTimeout(() => { try { window.turnstile.remove(id); } catch (e) {} box.remove(); }, 0);
      fn(v);
    };
    const timer = setTimeout(() => done(reject, captchaError(lastCode || 'timeout')), 45000);
    id = window.turnstile.render(box, {
      sitekey: TURNSTILE_SITE_KEY, appearance: 'interaction-only', language: 'cs', retry: 'auto',
      callback: (t) => done(resolve, t),
      'error-callback': (code) => {
        lastCode = String(code || '');
        console.warn('Turnstile chyba', lastCode);
        if (/^(1|4)/.test(lastCode)) { done(reject, captchaError(lastCode)); return true; }
        // jinak nechat Turnstile zkusit znovu (vrácení false = výchozí chování)
      },
      'expired-callback': () => { try { window.turnstile.reset(id); } catch (e) {} },
      'timeout-callback': () => { try { window.turnstile.reset(id); } catch (e) {} },
    });
  }));
}

// Token připravený dopředu (po otevření formuláře), aby přihlášení nečekalo
// na Cloudflare. Token platí 300 s a jde použít jen jednou.
const TOKEN_TTL_MS = 270 * 1000;
let ready = null; // { promise, at }
let lastContainer = null;
export function prefetchCaptcha(container) {
  if (!TURNSTILE_SITE_KEY || ready) return;
  lastContainer = container || null;
  const p = freshToken(container);
  ready = { promise: p, at: Date.now() };
  p.catch(() => { if (ready && ready.promise === p) ready = null; });
}

// Jednorázový token pro jedno volání Supabase Auth — připravený, je-li čerstvý,
// jinak nový.
export function captchaToken(container) {
  if (!TURNSTILE_SITE_KEY) return Promise.resolve(undefined);
  const r = ready;
  ready = null;
  const p = (r && Date.now() - r.at < TOKEN_TTL_MS) ? r.promise.catch(() => freshToken(container)) : freshToken(container);
  // další pokus (např. po špatném heslu) už zase nečeká
  if (lastContainer && lastContainer.isConnected) p.then(() => prefetchCaptcha(lastContainer), () => {});
  return p;
}
